import Index from "../../views/main/fieldGroups/Index";
import Create from "../../views/main/fieldGroups/Create";
import Edit from "../../views/main/fieldGroups/Edit";

export default [
  {
    component: Index,
    name: 'field-groups-index',
    path: '/field-groups',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'fields',
    }
  },
  {
    component: Create,
    name: 'field-groups-create',
    path: '/field-groups/create',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'fields',
    }
  },
  {
    component: Edit,
    name: 'field-groups-edit',
    path: '/field-groups/edit/:id',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'fields',
    }
  },
]
